"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getArgs = exports.getCacheKey = void 0;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/explicit-function-return-type
function getCacheKey(_a, extras) {
    var path = _a[0], input = _a[1];
    var cacheKey = [path, input !== null && input !== void 0 ? input : null];
    if (extras) {
        cacheKey.push(extras);
    }
    return cacheKey;
}
exports.getCacheKey = getCacheKey;
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/explicit-function-return-type
function getArgs(pathAndInput, opts) {
    var path = pathAndInput[0], input = pathAndInput[1];
    return [path, input, opts];
}
exports.getArgs = getArgs;
